import { IconButton } from "@mui/material";
import { ResourceHeaderStyled } from "./resource-header.styles";
import { ChevronLeft } from "@mui/icons-material";
import { Typography } from "@mui/material";

const ResourceHeader = (props) => {
  const { title, subTitle, rightContent, onBack } = props;
  return (
    <ResourceHeaderStyled>
      <div className="heading-content">
        <IconButton onClick={onBack}>
          <ChevronLeft />
        </IconButton>

        <div className="text-flex">
          <Typography variant="h6">{title} </Typography>
          <Typography variant="body3">{subTitle}</Typography>
        </div>
      </div>

      <div>{rightContent}</div>
    </ResourceHeaderStyled>
  );
};

export default ResourceHeader;
